import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LoginService } from '../../../../../../services/login/login.service';
import { BusquedaProductosService } from '../../utils/services/busqueda-productos.service';
import { takeUntil } from 'rxjs/operators';
import { autocompleteGroup } from '../../utils/models/Search';


@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit {
  @ViewChild('input') input: ElementRef;
  @ViewChild('autocomplete') autocomplete: ElementRef;
  @Output() search = new EventEmitter<any>();
  public formulario: FormGroup;
  public focoInput = false;
  public storeGrupoSugerido = false;
  public existencia = Math.floor(Math.random() * (10 - 1)) + 2;
  private indexFocus = - 1;
  public options = []
  public showNavList: boolean;
  public showBackgroud: boolean;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private headerService: BusquedaProductosService,
  ) { }

  ngOnInit() {
    this.showNavList = true;
    this.getDataAutoComplete();
    this.buildForm();
    this.formulario.get('search').valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      this.indexFocus = -1;
    });
  }

  initializeFunction(): void {
    this.showPanel(true);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /**
   * este metodo es para traer las categorías e insertarlo en
   * el autocompletado del buscador
   */
  private getDataAutoComplete = (): void => {
    this.headerService.searchAutocomplete('').pipe(takeUntil(this.unsubscribe$)).subscribe((result: autocompleteGroup) => {

      this.options = result.grupos.map(item => { return item.Nombre });
    });
  }

  private buildForm = (): void => {
    this.formulario = this.formBuilder.group({
      search: ['', [Validators.required]],
      searchEspecifica: [false],
    });
  }

  /**
     * Metodo para hacer la busqueda con el submit
     * @param event es el parametro event pare evitar recargar la pagiona
     */
  public submit = (event) => {
    //console.log("EVENTO EN SUBMIT",event)
    event.preventDefault();
    if (this.formulario.valid) {

      this.showPanel(false);
      const busqueda = this.getValue();
      this.search.emit(busqueda);
    }
  }

  public getSearchEspecific = () => {
    return this.formulario.get('searchEspecifica').value;
  }

  public cleanText = (clave: string): string => {
    clave = clave.toLowerCase();
    clave = clave.replace(' de ', ' ');
    return clave.replace(/ /g, '%');
  }

  public setValue = (value): void => {
    this.formulario.get('search').setValue(value);
  }

  public getValue = (): string => {
    if (this.getSearchEspecific()) {
      // transformamos
      return this.cleanText(this.formulario.get('search').value);
    } else {
      // no tranformamos
      return this.formulario.get('search').value;
    }
  }

  public cleanSearch = (): void => {
    this.setValue('');
  }

  public searching = (item): void => {

    this.search.emit(item);
    this.showPanel(false);
  }

  /**
     * Este metodo es el que se ejecuta cuando el usuario precion la tecla de
     * ir abajo o arriba en el buscador -- esto para seleccionar el item del autocompletado
     * @param event el evento del teclado
     */
  select = (event: KeyboardEvent) => {
    // console.log('Is evento key code ', event)
    const parent = this.autocomplete.nativeElement.querySelectorAll('a');
    const parentText = this.autocomplete.nativeElement.querySelectorAll('b');
    parent.forEach(element => {
      element.classList.remove('item-active');
    });

    switch (event.keyCode) {

      case 40:
        if (this.indexFocus < parent.length - 1) {
          this.indexFocus++;
        } else {
          this.indexFocus = 0;
        }
        parent[this.indexFocus].focus();
        this.input.nativeElement.focus();
        parent[this.indexFocus].classList.add('item-active');
        break;
      case 38:
        if (this.indexFocus <= 0) {
          this.indexFocus = parent.length - 1;
        } else {
          this.indexFocus--;
        }
        parent[this.indexFocus].focus();
        this.input.nativeElement.focus();
        parent[this.indexFocus].classList.add('item-active');
        break;
      case 13:
        if (this.indexFocus !== -1) {
          this.storeGrupoSugerido = true;
          this.setValue(parentText[this.indexFocus].textContent);
          this.indexFocus = -1;
        }
        break;
      case 27:
        this.showPanel(false);
        break;
    }
  }

  public showPanel(onClick: boolean): void {
    this.showNavList = onClick;
    this.showBackgroud = onClick;
  }

  public getTime = (): number => {
    return new Date().getTime()
  }
}
